module.exports = __webpack_public_path__ + "media/tulum/beach_view-4a43932f.jpg";